import React, { useCallback, useEffect, useState } from "react";
import { getMyInquiries } from "../customerApi";
import { useMyText } from "./text";
import { useLanguage } from "../../i18n/LanguageContext";
import { fmtAt, isOpen, kindLabel } from "./format";
import { PageTop, StatusTag, ChannelTag, Steps, StateNote, LoadState } from "./parts";

// 내 문의 현황 #inq — 전체 · 진행 중(접수·처리 중·보류) · 완료
export default function InquiryList({ go, customer }) {
    const tt = useMyText();
    const { lang } = useLanguage();
    const [items, setItems] = useState([]);
    const [state, setState] = useState("loading");
    const [tab, setTab] = useState("all");
    const load = useCallback(() => {
        setState("loading");
        getMyInquiries().then((l) => { setItems(l); setState("ok"); }).catch(() => setState("error"));
    }, []);
    useEffect(() => { load(); }, [load]);

    const open = items.filter((q) => isOpen(q.status));
    const done = items.filter((q) => q.status === "completed");
    const rows = tab === "open" ? open : tab === "done" ? done : items;
    const openCard = (id) => go(`inq/${id}`);
    return (
        <div className="my-wrap">
            <PageTop title={tt("inq.title")} desc={tt("inq.desc")} customer={customer} onBack={() => go("")} />
            {state !== "ok" ? <LoadState state={state} onRetry={load} onList={() => go("")} /> : (
                <>
                    <div className="my-seg" role="tablist">
                        {[["all", items.length], ["open", open.length], ["done", done.length]].map(([k, n]) => (
                            <button key={k} type="button" role="tab" aria-selected={tab === k} className={tab === k ? "on" : ""} onClick={() => setTab(k)}>
                                {tt(`tab.${k}`)}<em>{n}</em>
                            </button>
                        ))}
                    </div>
                    {rows.length === 0 ? (
                        <div className="my-empty">{tt(tab === "open" ? "empty.open" : "empty.all")}<small>{tt("empty.hint")}</small></div>
                    ) : rows.map((q) => (
                        <div key={q.id} data-id={q.id} className="my-card" role="button" tabIndex={0}
                            onClick={() => openCard(q.id)} onKeyDown={(e) => { if (e.key === "Enter") openCard(q.id); }}>
                            <div className="my-card-h">
                                <StatusTag status={q.status} /><ChannelTag channel={q.channel} />
                                <span className="kind">{kindLabel(q, lang)}</span>
                                {q.unread && <span className="my-unread" aria-hidden="true" />}
                                <span className="at">{fmtAt(q.created_at, lang)}</span>
                            </div>
                            <div className="my-card-t">{q.request_content}</div>
                            <Steps status={q.status} />
                            <StateNote item={q} />
                        </div>
                    ))}
                </>
            )}
        </div>
    );
}
